import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router';

// Helpers
import { getURLSegment, toggleDrawer } from '../../helpers/helpers.js';

// Translations
import translate from '../Translate.js';

// Components
import * as icons from '../Icons/Icons';
import Drawer from '../Drawer/Drawer';

const SelfManagedAccounts = observer(class SelfManagedAccounts extends React.Component {
  componentWillMount() {
    this.state = {
      drawerOpen: false,
      drawerContent: null
    }
    this.props.store.ProctorStore.listSelfManagedAccount();
  }

  componentDidMount() {
    const { pathname } = this.props.routing.location;

    if(pathname.indexOf('/add') > -1 || pathname.indexOf('/edit') > -1) {
      toggleDrawer(null, this, 'AddSelfManagedAccount');
    }
  }

  renderResults() {
    const { translation } = this.props;
    const { ProctorStore, SessionStore } = this.props.store;

    if(ProctorStore.selfManagedAccounts.length > 0) {
      return (
        <table>
          <thead>
            <tr>
              <th id="heading-name" className="subtitle" scope="col">
                {translation.name}
              </th>
              <th id="heading-org" className="subtitle" scope="col">
                {translation.organization}
              </th>
              <th id="heading-email" className="subtitle" scope="col">
                {translation.email}
              </th>
            </tr>
          </thead>
          <tbody>
            {ProctorStore.selfManagedAccounts.map(
              (key, i) =>
              <tr key={i}>
                <td aria-labelledby="heading-name">
                  <Link
                    to={`${getURLSegment(this, 1)}/edit/${key.sid}`}
                    title={`Edit ${key.lastName}, ${key.firstName}`}
                  >
                    {key.lastName}, {key.firstName}
                  </Link>
                </td>
                <td aria-labelledby="heading-org">
                  {key.company}
                </td>
                <td aria-labelledby="heading-email">
                  <a className="title-link" href={`mailto:${key.email}`}>{key.email}</a>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )
    } else if(!SessionStore.loading) {
      return (
        <span className="no-results">{translation.no_results}</span>
      )
    }

    return null;
  }

  render() {
    const { translation } = this.props;

    return (
      <main tabIndex="0" id="main-content" className="page">
        <header className="page__header">
          <div className="wrap">
            <h1 className="page__title">{translation.page_title}</h1>

            <div className="page__actions actions">
              <Link to="self-managed-proctors/add" className="btn--outline">
                <icons.iconPlus />
                {translation.button}
              </Link>
            </div>
          </div>
        </header>

        <div className="wrap">
          {this.renderResults()}
        </div>

        <Drawer content={this.state.drawerContent} isOpen={this.state.drawerOpen} parent={this} single={true} vouchers={this.state.vouchers} {...this.props} />
      </main>
    )
  }
})

export default translate('SelfManagedAccounts')(SelfManagedAccounts);



// WEBPACK FOOTER //
// ./src/app/components/SelfManagedAccounts/SelfManagedAccounts.js